<template lang="pug">
    nav.global_navigation
        button.global_hamburger_button(
            name="menu"
            type="button"
            style="pointer-events: none;")
            .global_hamburger_button_left
            .global_hamburger_button_right
        #js_global_navigation_content.global_navigation_content
            ul.global_navigation_list
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='service')}" style="pointer-events: none;") SERVICE
                        span - サービス
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='works')}" style="pointer-events: none;") WORKS
                        span - プロジェクト実績
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='articles')}" style="pointer-events: none;") ARTICLES
                        span - メディア
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='company')}" style="pointer-events: none;") COMPANY
                        span - 会社情報
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='news')}" style="pointer-events: none;") NEWS
                        span - ニュース
                li.global_navigation_item
                    a(href="#" :class="{'is_active': (content=='recruit')}" style="pointer-events: none;") RECRUIT
                        span - 採用情報
                li.global_navigation_item
                    a(href="#" target="_blank" rel="noopener" style="pointer-events: none;") CONTACT
                        span - お問い合わせ
</template>

<script>

export default {
    name: 'public_global_navigation',
    computed: {
        content(){
            return this.$store.state.content
        }
    }
}
</script>
